import * as React from "react"
import type { SVGProps } from "react"
const SvgPause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 19.43q-.83 0-1.41-.59a2 2 0 0 1-.59-1.41v-10q0-.82.59-1.41a2 2 0 0 1 1.41-.6q.83 0 1.41.6.6.59.59 1.4v10q0 .84-.59 1.42a2 2 0 0 1-1.41.59m-8 0q-.82 0-1.41-.59A2 2 0 0 1 6 17.43v-10q0-.82.59-1.41A2 2 0 0 1 8 5.42q.82 0 1.41.6.6.59.59 1.4v10q0 .84-.59 1.42a2 2 0 0 1-1.41.59" />
  </svg>
)
export default SvgPause
